import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect (): void {
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit (event: Event): void {
    event.preventDefault()

    const form = this.element as HTMLFormElement
    const url = form.action
    const formData = new FormData(form)

    const csrfToken = document.querySelector('meta[name="csrf-token"]')
    const token = csrfToken?.getAttribute('content') ?? ''

    void fetch(url, {
      method: 'DELETE',
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': token
      },
      body: formData
    })
      .then(async response => await response.text())
      .then(html => {
      // @ts-expect-error - Turbo global is available in the browser
        Turbo.renderStreamMessage(html)

        if (window.location.pathname.match(/\/risks\/library\/\d+$/) != null) {
          history.replaceState({}, '', '/risks/library')
        }
      })
      .catch(error => {
        console.error('Error processing delete request:', error)
      })
  }
}
